import { User } from '@surface-elements/users/domain';

export interface ApiKey {
  _id: string;
  tokenPrefix: string;
  name: string;
  scopes: string[];
  user?: { email?: { emailAddress: string } };
  createdAt: string;
  lastUsedAt: string | null;
  revoked: string | null;
  revokedBy: string | null;
  expires: string | null;
  isActive: boolean;
}

export interface CreateApiKeyResponse {
  id: string;
  name: string;
  tokenPrefix: string;
  scopes: string[];
  rawToken: string;
  createdAt: string;
  message: string;
}

export interface RevokeApiKeyResponse {
  message: string;
  id: string;
}

export interface RevokeUserTokensResponse {
  message: string;
  revokedCount: number;
}

export interface UserToken {
  _id: string;
  created: string;
  expires: string;
  createdByIp: string | null;
  isActive: boolean;
  isExpired: boolean;
}

export interface UserTokensResponse {
  tokens: UserToken[];
  activeCount: number;
}

export interface State {
  users: User[];
  loading: boolean;
  error: string | null;
  apiKeys: ApiKey[];
  apiKeysLoading: boolean;
  apiKeysError: string | null;
  createdApiKey: CreateApiKeyResponse | null;
  expandedUserId: string | null;
  userTokens: UserToken[];
  userTokensLoading: boolean;
  userTokensError: string | null;
}

export const initialState: State = {
  users: [],
  loading: false,
  error: null,
  apiKeys: [],
  apiKeysLoading: false,
  apiKeysError: null,
  createdApiKey: null,
  expandedUserId: null,
  userTokens: [],
  userTokensLoading: false,
  userTokensError: null,
};
